(function () {
  'use strict';

  var DRAWER_ID   = 'loyalty-drawer';
  var BACKDROP_ID = 'loyalty-backdrop';
  var DATA_ID     = 'loyalty-widget-data';
  var OPEN_CLASS  = 'lw-drawer--open';
  var BG_CLASS    = 'lw-backdrop--visible';
  var BODY_LOCK   = 'lw-body-locked';

  var currentPoints = 0;
  var customerId    = '';
  var shopDomain    = '';
  var claimedCodes  = [];

  // ─── CSS supplémentaire (états dynamiques non couverts par la section) ────────
  function injectDynamicStyles() {
    if (document.getElementById('lw-dyn-styles')) return;
    var s = document.createElement('style');
    s.id = 'lw-dyn-styles';
    s.textContent = [
      '.lw-countdown{font-size:.75rem;color:#888;display:inline-flex;align-items:center;gap:4px;}',
      '.lw-msg-ok{font-size:.75rem;color:#15803d;font-weight:600;}',
      '.lw-msg-err{font-size:.75rem;color:#dc2626;font-weight:600;}',
      '.lw-code-box{margin-top:8px;display:flex;align-items:center;gap:8px;}',
      '.lw-code{font-family:monospace;font-size:.88rem;font-weight:800;letter-spacing:.1em;color:#0d1b8e;background:rgba(13,27,142,.08);padding:6px 12px;border-radius:8px;}',
      '.lw-copy-btn{font-size:.75rem;padding:4px 10px;border-radius:8px;border:1px solid #d1d5db;background:#fff;cursor:pointer;color:#555;font-weight:600;}',
      '.lw-claim-btn:disabled,.lw-redeem-btn:disabled{opacity:.5;cursor:default;pointer-events:none;}',
      '.lw-header{position:relative;flex-shrink:0;padding:16px 20px;background:#0d1b8e;display:flex;align-items:center;gap:12px;}',
      '.lw-header__logo{width:36px;height:36px;border-radius:8px;object-fit:cover;}',
      '.lw-header__logo--fallback{width:36px;height:36px;border-radius:8px;background:#FFD600;color:#0d1b8e;display:flex;align-items:center;justify-content:center;font-weight:900;font-size:1rem;}',
      '.lw-header__titles{display:flex;flex-direction:column;gap:2px;}',
      '.lw-header__program{font-size:.9rem;font-weight:800;color:#FFD600;line-height:1.2;}',
      '.lw-header__sub{font-size:.72rem;color:rgba(255,255,255,.6);}',
      '.lw-header__close{margin-left:auto;background:rgba(255,255,255,.15);border:none;cursor:pointer;color:#fff;font-size:1.3rem;line-height:1;width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;transition:background .2s;}',
      '.lw-header__close:hover{background:rgba(255,255,255,.3);}',
    ].join('');
    document.head.appendChild(s);
  }

  // ─── Solde ────────────────────────────────────────────────────────────────────
  function updatePointsDisplay(pts) {
    currentPoints = parseInt(pts, 10) || 0;
    var el = document.getElementById('loyalty-points-count');
    if (el) el.textContent = currentPoints.toLocaleString('fr-FR');
  }

  // ─── Claim (social, 30s countdown) ───────────────────────────────────────────
  function bindClaimButtons() {
    document.querySelectorAll('.lw-claim-btn').forEach(function(btn) {
      if (btn._lwBound) return;
      btn._lwBound = true;

      var code = btn.dataset.code;
      if (code && claimedCodes.indexOf('mn_claimed_' + code) !== -1) {
        btn.disabled = true;
        btn.textContent = '✓ Réclamé';
        btn.style.opacity = '0.5';
        btn.style.cursor = 'default';
        return;
      }

      btn.addEventListener('click', function() {
        var code  = btn.dataset.code;
        var link  = btn.dataset.link;
        if (!code) return;

        if (link) window.open(link, '_blank', 'noopener');

        btn.disabled = true;
        document.querySelectorAll('.lw-claim-btn').forEach(function(b) { if (!b.disabled) { b.disabled = true; b._lwLocked = true; } });
        var actionsDiv = btn.parentNode;
        var seconds = 15;
        actionsDiv.innerHTML = '<span class="lw-countdown">⏳ Validation dans ' + seconds + 's…</span>';

        var timer = setInterval(function() {
          seconds--;
          var cd = actionsDiv.querySelector('.lw-countdown');
          if (seconds > 0) {
            if (cd) cd.textContent = '⏳ Validation dans ' + seconds + 's…';
          } else {
            clearInterval(timer);
            if (cd) cd.textContent = '⏳ Envoi…';
            fetch('/apps/loyalty/claim-action?shop=' + encodeURIComponent(shopDomain), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ shop: shopDomain, customerId: customerId, code: code }),
            })
            .then(function(r) { return r.json(); })
            .then(function(data) {
              document.querySelectorAll('.lw-claim-btn').forEach(function(b) { if (b._lwLocked) { b.disabled = false; b._lwLocked = false; } });
              if (data.ok) {
                var earned = data.points - currentPoints;
                actionsDiv.innerHTML = '<span class="lw-msg-ok">✓ +' + earned + ' pts crédités !</span>';
                updatePointsDisplay(data.points);
                claimedCodes.push('mn_claimed_' + code);
              } else if (data.error === 'already_claimed') {
                actionsDiv.innerHTML = '<span class="lw-msg-err">Déjà réclamé.</span>';
              } else {
                actionsDiv.innerHTML = '<span class="lw-msg-err">Erreur, réessayez.</span>';
              }
            })
            .catch(function() {
              document.querySelectorAll('.lw-claim-btn').forEach(function(b) { if (b._lwLocked) { b.disabled = false; b._lwLocked = false; } });
              actionsDiv.innerHTML = '<span class="lw-msg-err">Erreur réseau.</span>';
            });
          }
        }, 1000);
      });
    });
  }

  // ─── Redeem ──────────────────────────────────────────────────────────────────
  function bindRedeemButtons() {
    document.querySelectorAll('.lw-redeem-btn').forEach(function(btn) {
      if (btn._lwBound) return;
      btn._lwBound = true;

      btn.addEventListener('click', function() {
        var code = btn.dataset.code;
        if (!code) return;

        var actionsDiv = btn.parentNode;
        // Bloquer tous les boutons redeem pour éviter la race condition sur le metafield
        document.querySelectorAll('.lw-redeem-btn').forEach(function(b) { b.disabled = true; });
        btn.textContent = 'Génération…';

        fetch('/apps/loyalty/redeem?shop=' + encodeURIComponent(shopDomain), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ shop: shopDomain, customerId: customerId, code: code }),
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.ok) {
            updatePointsDisplay(data.newBalance);
            addMyCode(data.code, data.isShipping, data.discountPct, data.expiresAt);
            actionsDiv.innerHTML = '<div class="lw-code-box">'
              + '<span class="lw-code">' + data.code + '</span>'
              + '<button class="lw-copy-btn" onclick="navigator.clipboard.writeText(\'' + data.code + '\');this.textContent=\'✓\';setTimeout(function(){this.textContent=\'Copier\'},1500)">Copier</button>'
              + '</div>';
            // Réactiver les autres boutons redeem (sauf celui-ci, remplacé par le code)
            document.querySelectorAll('.lw-redeem-btn').forEach(function(b) { b.disabled = false; });
          } else if (data.error === 'insufficient_points') {
            actionsDiv.innerHTML = '<span class="lw-msg-err">Points insuffisants.</span>';
          } else {
            document.querySelectorAll('.lw-redeem-btn').forEach(function(b) { b.disabled = false; });
            btn.textContent = 'Échanger';
          }
        })
        .catch(function() {
          document.querySelectorAll('.lw-redeem-btn').forEach(function(b) { b.disabled = false; });
          btn.textContent = 'Échanger';
        });
      });
    });
  }

  // ─── Mes codes de réduction ───────────────────────────────────────────────────
  var myCodesLoaded = false;

  var CODE_ICONS = {
    shipping: {
      bg: 'rgba(22,163,74,.1)',
      svg: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    },
    premium: {
      bg: 'rgba(217,119,6,.1)',
      svg: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9.5V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2.5a2.5 2.5 0 0 0 0 5V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2.5a2.5 2.5 0 0 0 0-5Z"/><line x1="8" y1="12" x2="16" y2="12" stroke-width="2.5"/></svg>',
    },
    simple: {
      bg: 'rgba(124,58,237,.1)',
      svg: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 9.5V7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2.5a2.5 2.5 0 0 0 0 5V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2.5a2.5 2.5 0 0 0 0-5Z"/><line x1="9" y1="12" x2="15" y2="12"/></svg>',
    },
  };

  function getCodeIcon(c) {
    if (c.isShipping) return CODE_ICONS.shipping;
    if ((c.discountPct || 0) >= 10) return CODE_ICONS.premium;
    return CODE_ICONS.simple;
  }

  function renderMyCodes(codes, txtEmpty, txtCopy, txtExpires, txtUsed, txtExpired) {
    var list = document.getElementById('lw-my-codes-list');
    if (!list) return;
    if (!codes || codes.length === 0) {
      list.innerHTML = '<div class="lw-my-codes__empty">' + txtEmpty + '</div>';
      return;
    }
    list.innerHTML = codes.map(function(c) {
      var code      = typeof c === 'string' ? c : c.code;
      var used      = c && c.used;
      var expiresAt = c && c.expiresAt ? new Date(c.expiresAt) : null;
      var expired   = expiresAt && expiresAt < new Date();
      var expiryStr = expiresAt
        ? (expired ? 'Expiré' : (txtExpires || 'Expire le :') + ' ' + expiresAt.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' }))
        : '';
      var icon = typeof c === 'object' ? getCodeIcon(c) : CODE_ICONS.simple;
      return '<div class="lw-my-codes__item" style="' + ((used || expired) ? 'opacity:.45;' : '') + '">'
        + '<div style="display:flex;align-items:center;gap:10px;">'
        + '<div style="flex-shrink:0;width:36px;height:36px;border-radius:8px;background:' + icon.bg + ';display:flex;align-items:center;justify-content:center;">' + icon.svg + '</div>'
        + '<div style="display:flex;flex-direction:column;gap:3px;flex:1;min-width:0;">'
        + '<div style="display:flex;align-items:center;gap:8px;">'
        + '<span class="lw-my-codes__code">' + code + '</span>'
        + (used || expired
          ? '<span style="font-size:.75rem;color:#888;flex-shrink:0;">' + (used ? (txtUsed || 'Utilisé') : (txtExpired || 'Expiré')) + '</span>'
          : '<button class="lw-my-codes__copy" style="margin-left:auto;flex-shrink:0;" onclick="navigator.clipboard.writeText(\'' + code + '\');this.textContent=\'✓ ' + txtCopy + '\';var b=this;setTimeout(function(){b.textContent=\'' + txtCopy + '\'},2000)">' + txtCopy + '</button>')
        + '</div>'
        + (expiryStr ? '<div style="font-size:.72rem;color:#aaa;padding-left:2px;">' + expiryStr + '</div>' : '')
        + '</div>'
        + '</div>'
        + '</div>';
    }).join('');
  }

  function loadMyDiscounts() {
    if (myCodesLoaded) return;
    myCodesLoaded = true;
    var wrap = document.getElementById('lw-my-codes');
    if (!wrap) return;
    var txtEmpty   = wrap.dataset.textEmpty   || 'Aucun code pour l\'instant.';
    var txtCopy    = wrap.dataset.textCopy    || 'Copier';
    var txtExpires = wrap.dataset.textExpires || 'Expire le :';
    var txtUsed    = wrap.dataset.textUsed    || 'Utilisé';
    var txtExpired = wrap.dataset.textExpired || 'Expiré';

    var dataEl = document.getElementById(DATA_ID);
    var raw = dataEl && dataEl.dataset.myCodes;
    var codes;
    try { codes = JSON.parse(raw || '[]'); } catch (e) { codes = []; }
    renderMyCodes(codes, txtEmpty, txtCopy, txtExpires, txtUsed, txtExpired);
  }

  function addMyCode(couponCode, isShipping, discountPct, expiresAt) {
    var dataEl = document.getElementById(DATA_ID);
    if (!dataEl) return;
    var raw = dataEl.dataset.myCodes;
    var codes;
    try { codes = JSON.parse(raw || '[]'); } catch (e) { codes = []; }
    codes.unshift({ code: couponCode, createdAt: new Date().toISOString(), isShipping: !!isShipping, discountPct: discountPct || 0, ...(expiresAt && { expiresAt: expiresAt }) });
    dataEl.dataset.myCodes = JSON.stringify(codes);
    myCodesLoaded = false;
    loadMyDiscounts();
  }

  // ─── Drawer ───────────────────────────────────────────────────────────────────
  function openDrawer() {
    var drawer   = document.getElementById(DRAWER_ID);
    var backdrop = document.getElementById(BACKDROP_ID);
    if (!drawer) return;
    drawer.classList.add(OPEN_CLASS);
    backdrop.classList.add(BG_CLASS);
    document.body.classList.add(BODY_LOCK);
    var qs = document.getElementById('quintus-selector');
    if (qs) qs.style.visibility = 'hidden';
  }

  function closeDrawer() {
    var drawer   = document.getElementById(DRAWER_ID);
    var backdrop = document.getElementById(BACKDROP_ID);
    if (!drawer) return;
    drawer.classList.remove(OPEN_CLASS);
    backdrop.classList.remove(BG_CLASS);
    document.body.classList.remove(BODY_LOCK);
    var qs = document.getElementById('quintus-selector');
    if (qs) qs.style.visibility = 'visible';
  }

  // ─── Tabs ─────────────────────────────────────────────────────────────────────
  function setupTabs() {
    var tabs = document.querySelectorAll('.lw-tab');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        tabs.forEach(function(t) { t.classList.remove('lw-tab--active'); });
        tab.classList.add('lw-tab--active');
        var target = tab.getAttribute('data-tab');
        document.querySelectorAll('.lw-panel').forEach(function(panel) {
          panel.style.display = panel.id === 'loyalty-tab-' + target ? '' : 'none';
        });
        if (target === 'redeem') loadMyDiscounts();
      });
    });
  }

  // ─── Cacher le trigger quand un offcanvas Bootstrap est ouvert ───────────────
  var offcanvasCount = 0;
  function bindOffcanvasEvents() {
    ['offcanvas-cart', 'offcanvas-search', 'offcanvas-wishlist', 'offcanvas-menu'].forEach(function(id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('show.bs.offcanvas', function() {
        offcanvasCount++;
        var t = document.getElementById('loyalty-trigger');
        if (t) t.style.visibility = 'hidden';
        closeDrawer();
      });
      el.addEventListener('hidden.bs.offcanvas', function() {
        offcanvasCount = Math.max(0, offcanvasCount - 1);
        if (offcanvasCount === 0) {
          var t = document.getElementById('loyalty-trigger');
          if (t) t.style.visibility = '';
        }
      });
    });
  }

  // ─── Slideshow bannière ───────────────────────────────────────────────────────
  function setupSlideshow() {
    var el = document.getElementById('lw-slideshow');
    if (!el) return;
    var slides = el.querySelectorAll('.lw-slide');
    var dots   = el.querySelectorAll('.lw-dot');
    if (slides.length <= 1) return;
    var current = 0;
    function goTo(n) {
      slides[current].classList.remove('lw-slide--active');
      if (dots[current]) dots[current].classList.remove('lw-dot--active');
      current = ((n % slides.length) + slides.length) % slides.length;
      slides[current].classList.add('lw-slide--active');
      if (dots[current]) dots[current].classList.add('lw-dot--active');
    }
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goTo(parseInt(dot.dataset.slide, 10)); });
    });
    setInterval(function() { goTo(current + 1); }, 4000);
  }

  // ─── Init ─────────────────────────────────────────────────────────────────────
  function init() {
    injectDynamicStyles();

    var dataEl = document.getElementById(DATA_ID);
    if (dataEl) {
      customerId   = dataEl.dataset.customerId || '';
      shopDomain   = dataEl.dataset.shop || (window.Shopify && window.Shopify.shop) || '';
      claimedCodes = dataEl.dataset.claimedCodes
        ? dataEl.dataset.claimedCodes.split(',').map(function(t) { return t.trim(); })
        : [];
      updatePointsDisplay(dataEl.dataset.points || 0);
    }

    // Les cartes sont déjà dans le DOM (rendues par Liquid) — on bind juste les boutons
    setupSlideshow();
    bindClaimButtons();
    bindRedeemButtons();
    setupTabs();

    var closeBtn = document.getElementById('loyalty-close');
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    var backdrop = document.getElementById(BACKDROP_ID);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeDrawer(); });

    document.addEventListener('click', function(e) {
      var el = e.target.closest('[data-loyalty-open], a[href*="fidelite"], a[href*="loyalty"], a[href*="tcubes"]');
      if (!el) return;
      e.preventDefault();
      openDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { init(); bindOffcanvasEvents(); });
  } else {
    init();
    bindOffcanvasEvents();
  }

  document.addEventListener('shopify:section:load', init);

})();
